import { render, staticRenderFns } from "./SelectStudents.vue?vue&type=template&id=d7895eb6"
import script from "./SelectStudents.vue?vue&type=script&lang=js"
export * from "./SelectStudents.vue?vue&type=script&lang=js"
import style0 from "./SelectStudents.vue?vue&type=style&index=0&id=d7895eb6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports